(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lutrini-offer"] && !Shopify.designMode) return;
  try {
    
  function initLutriniOffers() {
    document.querySelectorAll('[data-lt-offer]').forEach(function (offer) {
      if (offer.dataset.ready === 'true') return;
      offer.dataset.ready = 'true';
      var idInput = offer.querySelector('[data-offer-id]');
      var price = offer.querySelector('[data-offer-price]');
      var compare = offer.querySelector('[data-offer-compare]');
      var buy = offer.querySelector('[data-offer-buy]');
      var buyLabel = offer.querySelector('[data-offer-buy-label]');
      var ctaText = buyLabel ? buyLabel.textContent : '';
      offer.querySelectorAll('.lt-offer__pill input').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          if (idInput) idInput.value = radio.value;
          if (price) price.textContent = radio.dataset.price;
          if (compare) {
            compare.textContent = radio.dataset.compare || '';
            compare.hidden = !radio.dataset.compare;
          }
          var available = radio.dataset.available === 'true';
          if (buy) buy.disabled = !available;
          if (buyLabel) buyLabel.textContent = available ? ctaText : 'Sold out';
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLutriniOffers); else initLutriniOffers();
  document.addEventListener('shopify:section:load', initLutriniOffers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lutrini-product"] && !Shopify.designMode) return;
  try {
    
  function initLutriniBuilders() {
    document.querySelectorAll('[data-lt-builder]').forEach(function (builder) {
      if (builder.dataset.ready === 'true') return;
      builder.dataset.ready = 'true';
      const input = builder.querySelector('[data-child-name]');
      const list = builder.querySelector('[data-choices]');
      const title = builder.querySelector('[data-preview-name]');
      const preview = builder.querySelector('[data-preview-steps]');
      const hidden = builder.querySelector('[data-steps-input]');
      const error = builder.querySelector('[data-step-error]');
      if (!input || !list || !title || !preview || !hidden) return;
      const defaultName = title.textContent;
      const render = function () {
        const checked = Array.from(list.querySelectorAll('[data-step-row]')).map(function (row) { return row.querySelector('[data-step]'); }).filter(function (box) { return box.checked; });
        title.textContent = input.value.trim() ? input.value.trim().slice(0, 24) + builder.dataset.titleSuffix : defaultName;
        hidden.value = checked.map(function (box) { return box.value; }).join(' → ');
        preview.replaceChildren();
        checked.forEach(function (box) { const item = document.createElement('li'); item.textContent = box.value; preview.appendChild(item); });
        if (error) error.textContent = checked.length < 3 ? builder.dataset.errorMin : (checked.length > 5 ? builder.dataset.errorMax : '');
      };
      input.addEventListener('input', render);
      list.addEventListener('change', render);
      list.addEventListener('click', function (event) {
        const button = event.target.closest('[data-move]');
        if (!button) return;
        const row = button.closest('[data-step-row]');
        if (!row) return;
        if (button.dataset.move === 'up' && row.previousElementSibling) list.insertBefore(row, row.previousElementSibling);
        if (button.dataset.move === 'down' && row.nextElementSibling) list.insertBefore(row.nextElementSibling, row);
        render();
      });
      const form = builder.querySelector('.lt-product__form');
      if (form) form.addEventListener('submit', function (event) {
        const count = list.querySelectorAll('[data-step]:checked').length;
        if (count < 3 || count > 5) { event.preventDefault(); render(); list.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLutriniBuilders); else initLutriniBuilders();
  document.addEventListener('shopify:section:load', initLutriniBuilders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
